import { getUiStateService } from '@/core/container/ioc'
import { computed, onScopeDispose } from '@/composition/vue/compositionApi'

export const useNotificationPosition = () => {
  const uiStateService = getUiStateService()

  const notificationTopOffset = computed(() => {
    return uiStateService.getNotificationTopOffset()
  })

  return {
    notificationTopOffset,
  }
}

export const useNotificationPositionSetter = () => {
  const uiStateService = getUiStateService()

  const previousTopOffset = uiStateService.getNotificationTopOffset()

  const setNotificationTopOffset = (offset: string | undefined) => {
    uiStateService.setNotificationTopOffset(offset)
  }

  onScopeDispose(() => {
    uiStateService.setNotificationTopOffset(previousTopOffset)
  })

  return {
    setNotificationTopOffset,
  }
}
